module.exports = __webpack_public_path__ + "img/table-remove-button.966dc067.svg";